import type { HeyApiBackend } from "@/api/api-error-normalization.ts";

import { normalizeHeyApiError } from "@/api/api-error-normalization.ts";

interface ApiResult<T, TError> {
  data: T | undefined;
  error?: TError;
  request: Request;
  response?: Response;
}

interface ApiSuccess<T> {
  data: T;
  request: Request;
  response: Response;
}

export const handleBackofficeResult = createApiResultHandler("backoffice-v2");
export const handleSubscriberResult = createApiResultHandler("subscriber-backend");

function createApiResultHandler(backend: HeyApiBackend) {
  return <T, TError>(result: ApiResult<T, TError>): ApiSuccess<T> => {
    if (result.response?.ok) {
      return result as ApiSuccess<T>;
    }

    throw normalizeHeyApiError(
      {
        error: result.error,
        status: result.response?.status,
        method: result.request.method,
        url: result.request.url,
        request: result.request,
        response: result.response,
      },
      backend,
    );
  };
}
